import DeliveredByWaldoBadge from './DeliveredByWaldoBadge';

export default DeliveredByWaldoBadge;
